import React from 'react'

import styled, { CSSObject } from '@emotion/styled'
import { Box, Color, useTheme, BoxProps } from '@gousto-internal/citrus-react'

import bgImageLargePng from './assets/background-large.png'
import bgImageSmallPng from './assets/background-small.png'

export const ValueForMoneyContainer = (props: BoxProps) => {
  const { theme } = useTheme()
  const Component = styled(Box)(() => ({
    ...(theme.responsiveStyle(
      [
        `65% bottom/639px no-repeat url(${bgImageSmallPng})`,
        `bottom/contain no-repeat url(${bgImageSmallPng})`,
        `30% 20%/cover no-repeat url(${bgImageLargePng})`,
      ],
      ['background'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

export const AdvantagesContainer = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    borderRadius: '1rem',
    ...(theme.responsiveStyle(
      [theme.color(Color.Transparent), '#ecedefb3'],
      ['backgroundColor'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}
